import { render, staticRenderFns } from "./EditAccounts.vue?vue&type=template&id=24f34f9d&"
import script from "./EditAccounts.vue?vue&type=script&lang=js&"
export * from "./EditAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports